

import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";


import MDBox from "components/MDBox";

import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for DashboardNavbar
import {
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";
import { Modal } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { changePassword } from "api/routes";
import MDTypography from "../../../components/MDTypography";
import { toast } from "react-toastify";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};
function DashboardNavbar() {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, fixedNavbar, openConfigurator } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const [password, setPassword] = useState({
    currentPassword: "",
    newPassword: "",
    repeatNewPassword: "",
  })

  useEffect(() => {

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /**
     The event listener that's calling the handleTransparentNavbar function when
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>password</Icon>} onClick={handleOpen} title="تغییر رمز عبور" />
      <NotificationItem icon={<Icon>logout</Icon>} onClick={() => { sessionStorage.removeItem('x-auth-token'); window.location.replace("/login") }} title="خروج از حساب کاربری" />
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: '#fff'
  });
  const submit = () => {
    if (password.currentPassword !== '' && password.newPassword !== '' && password.repeatNewPassword !== '') {
      if (password.newPassword === password.repeatNewPassword) {
        const data = {
          currentPassword: password.currentPassword,
          newPassword: password.newPassword,
        }
        changePassword(data, (isOk, data) => {
          if (!isOk) toast.error(data.message);
          else return window.location.reload();
        })
      } else return toast.error("رمز عبور جدید با تکرار آن یکسان نیست")
    } else return toast.error("لطفا تمامی فیلدها را پر کنید")
  }

  return (
    <>
      <MDBox color={"white"}>
        <IconButton sx={navbarIconButton} size="small" onClick={handleOpenMenu} disableRipple>
          <Icon sx={iconsStyle}>account_circle</Icon>
        </IconButton>
        <IconButton size="small" disableRipple>
          <MDTypography sx={{fontSize: 14}} color="white">{sessionStorage.getItem("fullname")}</MDTypography>
        </IconButton>
        <IconButton
          size="small"
          disableRipple
          style={{ color: '#fff' }}
          sx={navbarMobileMenu}
          onClick={handleMiniSidenav}
        >
          <Icon sx={iconsStyle} fontSize="medium">
            {miniSidenav ? "menu_open" : "menu"}
          </Icon>
        </IconButton>
        {renderMenu()}
      </MDBox>

      <Modal
        open={open}
        onClose={handleClose}
      >
        <MDBox sx={style} pt={4} pb={3} px={3}>
          <MDBox>
            <MDInput type="password" value={password.currentPassword} onChange={(event) => setPassword((prev) => ({ ...prev, currentPassword: event.target.value }))} label="رمز عبور فعلی" fullWidth />
          </MDBox>
          <MDBox mt={2}>
            <MDInput type="password" value={password.newPassword} onChange={(event) => setPassword((prev) => ({ ...prev, newPassword: event.target.value }))} label="رمز عبور جدید" fullWidth />
          </MDBox>
          <MDBox mt={2}>
            <MDInput type="password" value={password.repeatNewPassword} onChange={(event) => setPassword((prev) => ({ ...prev, repeatNewPassword: event.target.value }))} label="تکرار رمز عبور جدید" fullWidth />
          </MDBox>
          <MDBox mt={4} mb={1}>
            <MDButton onClick={submit} variant="gradient" color="info" sx={{ width: '120px' }}>
              ثبت
            </MDButton>
          </MDBox>
        </MDBox>
      </Modal>
    </>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
